import React from 'react'
import ReactGA from 'react-ga'
import styled from 'styled-components'
import { Bar } from 'react-chartjs-2'

import moment from 'moment'
import 'moment/locale/ko'

const comma = (x) => { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

const Box = styled.section`
  position: relative; box-sizing: border-box;
`

const Items = styled.section`
  position: relative; box-sizing: border-box;
  display: flex;
  @media screen and (max-width: 680px) { overflow: auto; }
`

const Item = styled.a`
  display: block; max-width: 25%; min-width: 25%;
  position: relative; box-sizing: border-box;
  padding: 0.5rem; flex: 1 1 100%; opacity: 0.70; transition: all 0.3s;
  @media screen and (max-width: 680px) { max-width: 100%; min-width: 100%; }
  & > div {
    position: relative; box-sizing: border-box;
    background: #0b0c11; border-radius: 0.5rem; 
    border: 3px solid #0b0c11;
    padding: 0.5rem; height: 100%;
    & small { color: #777; }
    & > header {
      display: block; box-sizing: border-box;
      padding-bottom: 1rem;
      & > div.headline {
      display: block; box-sizing: border-box;
        padding-bottom: 1rem;
      }
    }
    & > div.description {
      display: block; box-sizing: border-box;
      font-size: 0.9em; color: #929394;
      padding-bottom: 2rem;
    }
    & > div.symbols {
      display: block; box-sizing: border-box; transition: all 0.3s;
      display: flex; flex-wrap: wrap;
      div.symbol {
        background: white; border-radius: 50%;
        width: 40px; height: 40px; 
        display: flex; align-items: center; justify-content: center;
        margin: 0.2rem; 
        & > img {
          width: 30px; height: 30px; display: inline-block; margin: 0.15rem;
          border: 2px solid transparent;  border-radius: 50%;
        }
        &.up { border: 2px solid red; opacity: 1; }
        &.down { border: 2px solid blue;}
      }
    }
  }
  &.up > div { border-bottom: 3px solid red; }
  &.down > div { border-bottom: 3px solid blue;}
  &:first-child { opacity: 0.98 }
  &:hover {
    opacity: 1;
  }
`

class TimelineWidget extends React.Component {
  constructor(props) {
    super(props)
    this.state = { items: [] }

    this.timer = false
    this.initialize = this.initialize.bind(this)
    this.loadRSS = this.loadRSS.bind(this)
    this.run = this.run.bind(this)
  }

  componentDidMount() {
    this.initialize()
  }

  async loadRSS() {
    const that = this
    return await fetch('https://api.coinrbi.com/timeline')
      .then((response) => response.json().catch(e => { }))
      .then((datas) => {
        ReactGA.event({ category: 'AutoRSS', action: `Coin AutoRSS`, label: `AutoRSS` })
        that.setState({ items: datas || [] })
      })
      .catch(e => {
        console.log(`타임라인 데이터를 불러오지 못했습니다.`)
      })
  }

  async initialize() {
    const that = this
    await that.loadRSS()
    this.timer = window.setInterval(that.run, 3000 * 10)
  }

  async run() {
    const that = this
    await that.loadRSS()
  }

  componentWillUnmount() {
    if (this.timer) { window.clearInterval(this.timer) }
  }

  render() {
    const { inLink } = this.props
    let items = (this.state.items || []).slice(0, 4)
    if (!items.length) { return '' }

    const filterCoins = this.props.coins || []
    if (filterCoins && filterCoins.length) {
      items = items.filter(item => {
        if (!item.coins) { return false }
        const coins = item.coins || []
        const symbols = coins.map(coin => coin.name)
        return filterCoins.map((filterCoin) => symbols.includes(filterCoin)).includes(true)
      })
    }

    return (
      <Box>
        <Items>
          {items.map((item, idx) => {
            let coins = item.coins || []
            if (filterCoins && filterCoins.length) {
              coins = coins.filter(coin => {
                return filterCoins.includes(coin.name)
              })
            }
            const upCoins = coins.filter(coin => coin.stance === 'up')
            const downCoins = coins.filter(coin => coin.stance === 'down')

            const sentances = item.title.split(', ')

            const totalVolume = coins.reduce((s, coin) => s + coin.totalTradeAmount, 0)

            const itemProps = {}
            if (!inLink) { itemProps.target = '_blank' }

            const data = {
              labels: coins.map(coin => coin.korean_name),
              datasets: [
                {
                  label: 'Volumes',
                  data: coins.map(coin => coin.stance === 'up' ? coin.totalTradeAmount : -1 * coin.totalTradeAmount),
                  backgroundColor: coins.map(coin => coin.stance === 'up' ? (upCoins.length > downCoins.length ? 'red' : '#333')  : (upCoins.length > downCoins.length ? '#333' : 'blue')),
                  borderWidth: 0,
                },
              ],
            }

            const options = {
              indexAxis: 'y',
              plugins: { legend: { display: false } },
              scales: {
                x: { display: false },
                y: {  }
               }
            }

            return (
              <Item key={`${idx}`} href={`${item.link}?ref=timeline`} className={upCoins.length > downCoins.length ? 'up' : 'down'} {...itemProps}>
                <div>
                  <header>
                    <div className="headline">
                      <small>{sentances[0]} 타점분석 보고서</small><br />
                      <strong>{sentances[1]}, {sentances[2]} {upCoins.length > downCoins.length ? '🚅' : '🏃'}</strong>
                    </div>
                  </header>
                  <div className="description">{item.description}</div>
                  <div className="symbols">
                    {coins.map((coin, coinIdx) => <div key={`c${coinIdx}`} className={`${coin.stance} symbol`}><img src={`https://api.coinrbi.com/symbols/${coin.name}.png`} /></div>)}
                  </div>
                  {coins.length > 2 ? (
                    <div style={{ padding: '0.5rem 0' }}>
                      <Bar data={data} options={options} />
                    </div>
                  ) : null}
                </div>
              </Item>
            )
          })}
        </Items>
      </Box>
    )
  }
}

export default TimelineWidget